import HallUI from "../HallUI";
import Utils from "../../Shared/Utils";
import Player from "../../Models/Player";
import htmlBefore from "../../Shared/htmlBefore";
import htmlAfter from "../../Shared/htmlAfter";
import TaskHtmlBefore from "./TaskHtmlBefore";
import NetworkLogic from "../../Shared/NetworkLogic";
import UIManager from "../../Shared/UIManager";
import AudioManager from "../../Shared/AudioManager";
import CustomerServiceUI from "../CustomerServiceUI";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TaskAgent extends cc.Component {
    @property([cc.Node])
    gunPingArr : cc.Node[] = [];

    @property(cc.WebView)
    webV: cc.WebView = null;
    @property(cc.Node)
    layout: cc.Node = null;

    pos0: cc.Vec2;
    pos1: cc.Vec2;
    rankIndex = 0;
    index = 0;
    rankingList = [];

    data = null;
    allActivityNode = null;
    private bscroll: boolean = false;
    private  constHeight = 0;
    private cosntPosY= 0;
    speed = 1;
    private htmlContent: any;

    /**
     * rankingList: (50) [{…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}, {…}]
     shareTaskSet:
     agentCode: "z79kw2zsvcp5"
     agentRecruitmentDesc: "/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     agentRecruitmentTutorialText: "<p>123123</p>"
     auditMoney: 1
     descText: "SH"
     promoteTheAddress: "http://ygrnapp.fanyirong.com/?channelCode=default"
     scrollFlagAgent: true
     scrollFlagShare: true
     shareDesc: "http://api.fanyirong.com:8080/group1/zonghe/dca344995e1f7366940b21ad0eeaa345.png"
     shareImg: (6) ["http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg", "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"]
     shareMoney: 100
     shareSwitch: "0"
     shareText: "11"
     shareTutorial: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     taskHandleStatus: -1
     titleImg: (2) ["http://api.fanyirong.com:8080/group1/zonghe/dca344995e1f7366940b21ad0eeaa345.png", "http://api.fanyirong.com:8080/group1/zonghe/dca344995e1f7366940b21ad0eeaa345.png"]
     uploadImgTutorial: "http:
     */

    start () {
        this.pos0 = this.gunPingArr[0].position;
        this.pos1 = this.gunPingArr[1].position;
        this.constHeight = this.gunPingArr[0].height;
        this.cosntPosY = this.gunPingArr[0].position.y;
        UIManager.showLoadingUI();
        NetworkLogic.agentGetAgentRecruitment( function (rec) {
            this.data = rec;
            cc.log("==代理招募数据：",rec)
            this.rankingList = rec.rankingList;
            this.htmlContent = rec.shareTaskSet.agentRecruitmentTutorialText
            this.rankingList.length > 0 && this.setScrollData(this.rankingList)
            this.setWebView(this.htmlContent)
            UIManager.hideLoadingUI();
        }.bind(this),function (rec) {
            UIManager.hideLoadingUI();
            cc.log("====任务列表错误",rec);

        }.bind(this),)
    }
    onEnable(): void {
        if (this.htmlContent)
            this.setWebView(this.htmlContent)
    }

    onDisable(): void {
        this.webV.node.active = false;

    }

    onDestroy(): void {
        this.unscheduleAllCallbacks();
    }

    /**
     * agentTutorialList: Array(3)
     0:
     titleContent: "<p>111</p>"
     titleImg: "http://api.fanyirong.com:8080/group1/zonghe/4f855e4d9a749151397ccaf5c3633e98.jpg"
     __proto__: Object
     1: {titleImg: "http://api.fanyirong.com:8080/group1/zonghe/33de4c9b462c97c493662bcb5e83641f.jpg", titleContent: "<p>222</p>"}
     2: {titleImg: "http://api.fanyirong.com:8080/group1/zonghe/33de4c9b462c97c493662bcb5e83641f.jpg", titleContent: "<p>22</p>"}
     length: 3
     __proto__: Array(0)
     shareSwitch: "0"
     * @param data
     * @param allActivityNode
     */

    loadImge(url,spriteNode){
        cc.loader.load(url, function (err, texture) {
            if (!err && this.node) {
                if (cc.isValid(spriteNode)){
                    spriteNode.getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture);
                }
            }else {
                cc.log("===加载图片spAgent错误");
            }
        }.bind(this))
    }

    onBtnAgent(){
        AudioManager.playSound("button")
        let hallUI : HallUI = cc.find("Canvas/gameNode").getComponent("HallUI");
        let ui = hallUI.openChildUI(hallUI.pfbCustomerServiceUI)
        ui && (ui.getComponent(CustomerServiceUI).customerTypeName = "MT客服")
        this.node.parent.parent.destroy();
    }

    setScrollData(rankingList){
        for (let i = 0;i < this.gunPingArr[0].children.length;i++){
            let richText = this.gunPingArr[0].children[i].getComponent(cc.RichText);
            richText.string = this._getStr(rankingList[this.rankIndex]);
            this.rankIndex ++;
            this.rankIndex %= rankingList.length
        }
        for (let i = 0;i < this.gunPingArr[1].children.length;i++){
            let richText = this.gunPingArr[1].children[i].getComponent(cc.RichText);
            richText.string = this._getStr(rankingList[this.rankIndex]);
            this.rankIndex ++;
            this.rankIndex %= rankingList.length
        }
        this.bscroll = true;
    };

    rankListScroll(){
        this.schedule(function () {
            this.gunPing0.runAction(cc.sequence(cc.moveBy(0.2, cc.v2(0,502)),
                cc.callFunc(function () {
                    if (this.index%2 === 0){
                        this.gunPing0.position = this.pos1;
                        for (let i = 0;i < this.gunPing0.children.length;i++){
                            let richText = this.gunPing0.children[i].getComponent(cc.RichText);
                            richText.string = this._getStr(this.rankingList[this.rankIndex]);
                            this.rankIndex ++;
                            this.rankIndex %= this.rankingList.length
                        }
                    }
                }.bind(this))));
            this.gunPing1.runAction(cc.sequence(cc.moveBy(0.2, cc.v2(0,502)),
                cc.callFunc(function () {
                    if (this.index % 2 === 1){
                        this.gunPing1.position = this.pos1;
                        for (let i = 0;i < this.gunPing1.children.length;i++){
                            let richText = this.gunPing1.children[i].getComponent(cc.RichText);
                            richText.string = this._getStr(this.rankingList[this.rankIndex]);
                            this.rankIndex ++;
                            this.rankIndex %= this.rankingList.length
                        }
                    }
                    this.index ++ ;

                }.bind(this))));
        }.bind(this),2)

    }

    _getStr(data){
        let str = ""
        if (data.type === 1){
            str = `<color =#FFEB00>${data.userId}</color>领取<color =#0fffff>代理佣金</color><color =#FF0000>${data.brokerageMoney}</color>元`
        }else if (data.type === 2){
            str = `<color =#FFEB00>${data.userId}</color>领取<color =#0fffff>分享佣金</color><color =#FF0000>${data.shareBonusMoney}</color>元`
        }
        return str;
    }

    update(dt: number): void {
        if (!this.bscroll) return;
        if(this.rankingList.length <= 0){
            return;
        }
        for (let i = 0;i < this.gunPingArr.length;i++){
            let node = this.gunPingArr[i];
            node.position = cc.v2(node.position.x,node.position.y + this.speed) ;
            // cc.log("===nodeName:%s,node.position:(%s,%s)",node.name,node.position.x,node.position.y);
            if (node.position.y >= this.constHeight + this.cosntPosY){
                node.position = this.pos1 ;
                //cc.log("===进入条件nodeName:%s,node.position:(%s,%s)",node.name,node.position.x,node.position.y);
                for (let j = 0;j < node.children.length;j++){
                    let richText = node.children[j].getComponent(cc.RichText);
                    richText.string = this._getStr(this.rankingList[this.rankIndex]);
                    this.rankIndex ++;
                    this.rankIndex %= this.rankingList.length
                }
            }
        }
    }



    //设置内容
    setWebView(htmlContent){
        this.webV.node.active = true;
        let str = TaskHtmlBefore + htmlContent + htmlAfter;
        cc.log("=====webView1 str:",str);
        this.webV["_impl"].loadHTMLString(str);
        cc.sys.isNative && this.webV["_impl"]._iframe && this.webV["_impl"]._iframe.setBackgroundTransparent && this.webV["_impl"]._iframe.setBackgroundTransparent(true)
    }

    onBtnClose(){
        AudioManager.playSound("close")
        this.node.destroy();
    }

}
